export default __webpack_public_path__ + "static/media/foto_01.f4f2feea.jpg";